import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, change } from 'redux-form';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { ADDRESS_TYPE_HUB_CUSTOMER, ADDRESS_TYPE_ANOTHER_HUB, ADDRESS_TYPE_MERCHANT, ERROR_MESSAGES, ADDRESS_TYPE_MERCHANT_CUSTOMER } from 'src/utils/pnd/PndConstants';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { showNotification } from 'src/shared/components/Notification';
import renderSelectField from 'src/shared/components/form/Select';
import HubCustomerInformation from './HubCustomerInformation';
import HubDropOffRequiredLaterCustomerInformationInformation from './HubDropOffRequiredLaterCustomerInformationInformation';
import MerchantDropOffRequiredLaterCustomerInfo from './MerchantDropOffRequiredLaterCustomerInfo';
import MerchantCustomerDetails from './MerchantCustomerDetails';

const required = value => value ? undefined : 'Required'

const PickAndDropOrder = ({ dispatch, isInfo }) => {
    const [isSelectedMid, setSelectedMid] = useState(null);
    const [isHub, setHub] = useState([]);
    const [addressTypeId, setAddressTypeId] = useState(null);
    const [isMerchantPickUpPoint, setMerchantPickUpPoint] = useState([]);
    const [isMerchant, setMerchant] = useState([]);
    const [isSelectedAddressTypeIdPndTo, setSelectedAddressTypeIdPndTo] = useState(null);
    const [isCustomersId, setCustomersId] = useState([]);

    useEffect(() => {
        if (isInfo?.orderFromAddressTypeInfo?.orderAddressTypeId) {
            setAddressTypeId(isInfo.orderFromAddressTypeInfo.orderAddressTypeId);
            findAddressType(isInfo.orderFromAddressTypeInfo.orderAddressTypeId);
        }
        if (isInfo?.orderToAddressTypeInfo?.orderAddressTypeId) {
            setSelectedAddressTypeIdPndTo(isInfo.orderToAddressTypeInfo.orderAddressTypeId);
            findAddressTypePndTo(isInfo.orderToAddressTypeInfo.orderAddressTypeId);
        }
    }, [isInfo]);

    const getAllHubDetails = async () => {
        try {
            let hubIds = [];
            const response = await PndRestApi.GetAllHubDetails();
            if (response.status === 200 && response.data.status === 200) {
                response.data.data.forEach(item => {
                    hubIds.push({ "label": item.hubName, "value": item.hubId });
                });
                setHub(hubIds);
            } else {
                showNotification("theme-light", "ltr", `SuccessCode: ${response.data.status}`, `Message:${response.data?.message || "Error"}`);
            }
        } catch (error) {
            showNotification("theme-light", "ltr", "500", ERROR_MESSAGES.tryCatchError);
        }
    };

    const getAllMerchantDetails = async () => {
        try {
            let merchantIds = [];
            const response = await PndRestApi.GetAllMerchantDetails();
            if (response.status === 200 && response.data.status === 200) {
                response.data.data.forEach(item => {
                    merchantIds.push({ "label": item.merchantName, "value": item.merchantId });
                });
                setMerchant(merchantIds);
            } else {
                showNotification("theme-light", "ltr", `SuccessCode: ${response.data.status}`, `Message:${response.data.message}`);
            }
        } catch (error) {
            showNotification("theme-light", "ltr", "500", ERROR_MESSAGES.tryCatchError);
        }
    };

    const getAllCustomerDetails = async () => {
        try {
            let customersId = [];
            const response = await PndRestApi.GetAllHubCustomers();
            if (response.status === 200 && response.data.status === 200) {
                response.data.data.forEach(item => {
                    customersId.push({ "label": item.customerName, "value": item.hubCustomerId });
                });
                setCustomersId(customersId);
            } else {
                showNotification("theme-light", "ltr", `SuccessCode: ${response.data.status}`, `Message:${response.data?.message || "Error"}`);
            }
        } catch (error) {
            showNotification("theme-light", "ltr", "500", ERROR_MESSAGES.tryCatchError);
        }
    };

    const getAllMerchantPickupPointDetails = async (mid) => {
        try {
            setSelectedMid(mid);
            let pickUpPointsId = [];
            setMerchantPickUpPoint([]);
            const response = await PndRestApi.GetAllPickUpPointsDetails(mid);
            if (response.status === 200 && response.data.status === 200) {
                response.data.data.forEach(item => {
                    pickUpPointsId.push({ "label": item.collectionPointName, "value": item.pickUpPointPointId });
                });
                setMerchantPickUpPoint(pickUpPointsId);
            } else {
                showNotification("theme-light", "ltr", `SuccessCode: ${response.data.status}`, `Message:${response.data?.message || "Error"}`);
                dispatch(change('orderForm', `pickUpPoints`, null));
            }
        } catch (error) {
            showNotification("theme-light", "ltr", "500", ERROR_MESSAGES.tryCatchError);
        }
    };

    const findAddressType = (val) => {
        setAddressTypeId(val);
        if (val === ADDRESS_TYPE_MERCHANT) getAllMerchantDetails();
        if (val === ADDRESS_TYPE_HUB_CUSTOMER) getAllCustomerDetails();
        if (val === ADDRESS_TYPE_ANOTHER_HUB) getAllHubDetails();
    }

    const findAddressTypePndTo = (val) => {
        setSelectedAddressTypeIdPndTo(val);
        if (val === ADDRESS_TYPE_HUB_CUSTOMER) getAllCustomerDetails();
        if (val === ADDRESS_TYPE_ANOTHER_HUB) getAllHubDetails();
    }

    return (
        <div className="mt-2 text-dark">
            <Row className="g-3 mb-4">
                <Col lg={3} md={6}>
                    <div className="mb-2">
                        <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Pick Up From <span className='text-danger'>*</span></label>
                        <Field validate={[required]} name="orderFromAddressTypeInfo" component={renderSelectField} options={[
                            { value: 2, label: "Hub Customer" },
                            { value: 3, label: "Merchant" },
                            { value: 4, label: "Another Hub" },
                        ]} placeholder="Select Pickup Type" onChange={e => findAddressType(e?.value)} isDisabled={!!isInfo?.orderNo} />
                    </div>
                </Col>

                {addressTypeId === ADDRESS_TYPE_ANOTHER_HUB && (
                    <Col lg={3} md={6}>
                        <div className="mb-2">
                            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Source Hub <span className='text-danger'>*</span></label>
                            <Field validate={[required]} name="hubInfo" component={renderSelectField} options={isHub} placeholder="Select Hub" />
                        </div>
                    </Col>
                )}

                {addressTypeId === ADDRESS_TYPE_MERCHANT && (
                    <>
                        <Col lg={3} md={6}>
                            <div className="mb-2">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Merchant <span className='text-danger'>*</span></label>
                                <Field validate={[required]} name="merchantInfo" component={renderSelectField} options={isMerchant} placeholder="Select Merchant" onChange={e => getAllMerchantPickupPointDetails(e?.value)} isDisabled={!!isInfo?.orderNo} />
                            </div>
                        </Col>
                        <Col lg={2} md={6}>
                            <div className="mb-2">
                                <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Pickup Point <span className='text-danger'>*</span></label>
                                <Field validate={[required]} name="collectionPointId" component={renderSelectField} options={isMerchantPickUpPoint} placeholder="Select Point" isDisabled={!!isInfo?.orderNo} />
                            </div>
                        </Col>
                    </>
                )}

                <Col lg={addressTypeId === ADDRESS_TYPE_MERCHANT ? 4 : addressTypeId === ADDRESS_TYPE_ANOTHER_HUB ? 6 : 9} md={6}>
                    <div className="mb-2">
                        <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Drop Off To <span className='text-danger'>*</span></label>
                        <Row className="g-2">
                            <Col xs={6}>
                                <Field validate={[required]} name="orderToAddressTypeInfo" component={renderSelectField} options={[
                                    { value: 2, label: "Hub Customer" },
                                    { value: 4, label: "Another Hub" },
                                ]} placeholder="Select Delivery Destination" onChange={e => findAddressTypePndTo(e?.value)} isDisabled={!!isInfo?.orderNo} />
                            </Col>
                            {isSelectedAddressTypeIdPndTo === ADDRESS_TYPE_ANOTHER_HUB && (
                                <Col xs={6}>
                                    <Field validate={[required]} name="dropOffHubInfo" component={renderSelectField} options={isHub} placeholder="Select Target Hub" isDisabled={!!isInfo?.orderNo} />
                                </Col>
                            )}
                        </Row>
                    </div>
                </Col>
            </Row>

            <div className="border-top pt-4">
                {addressTypeId === ADDRESS_TYPE_HUB_CUSTOMER && (
                    <HubCustomerInformation isCustomersId={isCustomersId} />
                )}

                {addressTypeId !== ADDRESS_TYPE_HUB_CUSTOMER && isSelectedAddressTypeIdPndTo === ADDRESS_TYPE_HUB_CUSTOMER && (
                    <HubCustomerInformation isCustomersId={isCustomersId} />
                )}

                {addressTypeId === ADDRESS_TYPE_HUB_CUSTOMER && isSelectedAddressTypeIdPndTo === ADDRESS_TYPE_HUB_CUSTOMER && (
                    <HubDropOffRequiredLaterCustomerInformationInformation isCustomersId={isCustomersId} />
                )}

                {addressTypeId === ADDRESS_TYPE_MERCHANT_CUSTOMER && (
                    <MerchantCustomerDetails isCustomersId={isCustomersId} />
                )}

                {addressTypeId === ADDRESS_TYPE_MERCHANT_CUSTOMER && isSelectedAddressTypeIdPndTo === ADDRESS_TYPE_MERCHANT_CUSTOMER && (
                    <MerchantDropOffRequiredLaterCustomerInfo isCustomersId={isCustomersId} />
                )}
            </div>
        </div>
    );
};

PickAndDropOrder.propTypes = {
    isInfo: PropTypes.object,
};

export default connect()(reduxForm({
    form: "orderForm",
    enableReinitialize: false,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
})(PickAndDropOrder));
